import React from "react";
import { Button } from "react-bootstrap";
import { SuccessIcon } from "../Global/Icons";

type CompletionProps = {
  title: string;
  text: string;
  onContinue: () => void;
};

export default function Completion({ title, text, onContinue }: CompletionProps) {
  return (
    <div className="text-center py-5">
      <SuccessIcon />
      <h1 className="m-0">{title}</h1>
      <p>{text}</p>
      <Button onClick={onContinue}>Continue</Button>
    </div>
  );
}
